import { useTopDestinations } from './TopDestinations';

export default useTopDestinations;
